import Vue from 'vue';
import VueTour from 'vue-tour';

require('vue-tour/dist/vue-tour.css');

export default () => {
  // eslint-disable-next-line no-param-reassign
  Vue.use(VueTour);
};



// WEBPACK FOOTER //
// ./src/plugins/vue-tour.js